import { flow } from 'fp-ts/lib/function';
import * as A from 'fp-ts/Array';

export const getInitials = flow(
  (name: string) => name.replace(/[^a-zA-Z0-9\s]/gi, ''),
  (name: string) => name.split(' '),
  A.takeLeft(2),
  A.map((word) => word[0]),
  (words) => words.join(''),
);
